import type { CSSProperties, ReactNode } from 'react'

const linkStyle: CSSProperties = { color: '#189BD5' }

export function linkify(text: string): ReactNode[] {
  const parts = text.split(/(mail@titan-top\.ru|https?:\/\/[^\s)]+)/g)
  return parts.map((part, i) => {
    if (part === 'mail@titan-top.ru') {
      return <a key={i} href={`mailto:${part}`} style={linkStyle}>{part}</a>
    }
    if (/^https?:\/\//.test(part)) {
      return <a key={i} href={part} target="_blank" rel="noopener noreferrer" style={linkStyle}>{part}</a>
    }
    return part
  })
}
